export const growthSuggestions = {
  'ISTJ': {
    personalGrowth: {
      shortTerm: [
        '每周尝试一个新事物',
        '练习表达感受',
        '参与团队活动'
      ],
      longTerm: [
        '发展创新思维',
        '提高情商',
        '增强适应能力'
      ]
    },
    careerGrowth: {
      skills: [
        '项目管理',
        '团队领导',
        '战略思维'
      ],
      attitudes: [
        '开放心态',
        '灵活应变',
        '同理心'
      ]
    },
    relationships: {
      improvement: [
        '主动表达关心',
        '培养同理心',
        '增加社交互动'
      ],
      communication: [
        '练习积极倾听',
        '表达感受',
        '建立情感连接'
      ]
    }
  },
  // ... 其他类型的成长建议
}

export const developmentPaths = {
  E: {
    strengthen: ['提高表达能力', '扩展社交网络', '增强领导力'],
    balance: ['培养独处能力', '发展内省习惯', '深度思考']
  },
  I: {
    strengthen: ['提高独立工作能力', '发展深度思考', '培养专注力'],
    balance: ['适度参与社交', '学习表达想法', '建立必要的人际关系']
  },
  // ... 其他维度的发展路径
} 